/** Where the web store sends people to install: the Glassly App itself. */
// Tetramo's own listing (id 6798005690). Never point it at the upstream Mentra app id.
export const APP_STORE_URL = "https://apps.apple.com/us/app/glassly-smartglasses-app/id6798005690";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.tetramo.glassly";

export type Platform = "ios" | "android" | "other";

export function detectPlatform(): Platform {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
}
